import React from "react";
import { Card, Col } from "react-bootstrap";
import ApexCharts from "react-apexcharts";
import { useSelector } from "react-redux";

const RejectionRateByInsurance = () => {
  const { claimDashboardData } = useSelector((state) => state.claimDashboard);
  const claimPayers = claimDashboardData?.claim_payor || [];

  // Map claim_payor data to series and categories
  const rejectionRates = claimPayers.map((payer) => {
    const totalClaims = payer.tot_status.total || 0;
    const rejectedClaims = payer.tot_status.rejected || 0;
    return totalClaims ? ((rejectedClaims / totalClaims) * 100).toFixed(1) : 0;
  });

  const payorNames = claimPayers.map((payer) => payer.payor_name);

  const chartOptions = {
    series: [
      {
        name: "Rejection Rate",
        data: rejectionRates,
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 250,
        toolbar: { show: false },
        zoom: { enabled: false },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          borderRadius: 4,
        },
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: payorNames,
        labels: { rotate: -45, style: { fontSize: "10px" } },
      },
      yaxis: {
        min: 0,
        max: 100,
        tickAmount: 5,
        labels: { style: { fontSize: "10px" }, formatter: (val) => `${val}%` },
      },
      colors: ["#DC3545"], // Bootstrap danger red
      tooltip: {
        y: {
          formatter: (val) => `${val}%`,
        },
      },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "10px",
      },
    },
  };

  return (
    <Col xs={12}>
      <Card className="h-100 p-3">
        <Card.Header as="h6" className="fs-9 fw-normal text-primary">
          Rejection Rate by Insurance
        </Card.Header>
        <Card.Body className="p-2">
          <ApexCharts
            options={chartOptions.options}
            series={chartOptions.series}
            type="bar"
            height={250}
          />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default RejectionRateByInsurance;